import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header__main__mega" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row align-items-start" }
const _hoisted_4 = { class: "parent-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "col mt-3" }
const _hoisted_7 = { class: "row row-mega no-gutters io-eq" }
const _hoisted_8 = { class: "row no-gutters" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = { class: "row-mega-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import FaIcon from '@/components/FaIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeaderMegaMenu',
  props: {
  parent: {
    type: Object,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (__props.parent.icon)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "parent-icon",
                  style: _normalizeStyle({
                  backgroundImage: `url(${__props.parent.icon})`,
                })
                }, null, 4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "text-regular",
            innerHTML: __props.parent.subTitle || __props.parent.title
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (menuItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: menuItem.id,
                class: "eq-object pb-3"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_IoRouterLink, {
                    "link-url": menuItem.url,
                    "link-target": menuItem.target,
                    "link-title": menuItem.titleAttr,
                    active: menuItem.active,
                    class: _normalizeClass(__props.parent.color)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        (menuItem.faIcon)
                          ? (_openBlock(), _createBlock(FaIcon, {
                              key: 0,
                              icon: menuItem.faIcon
                            }, null, 8, ["icon"]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: menuItem.icon
                            }, null, 8, _hoisted_11))
                      ]),
                      _createElementVNode("span", {
                        class: "row-mega-title",
                        "data-eq-part": "title",
                        innerHTML: menuItem.title || ''
                      }, null, 8, _hoisted_12),
                      _createElementVNode("span", {
                        class: "row-mega-subtitle",
                        "data-eq-part": "subtitle",
                        innerHTML: menuItem.subTitle || ''
                      }, null, 8, _hoisted_13)
                    ]),
                    _: 2
                  }, 1032, ["link-url", "link-target", "link-title", "active", "class"]),
                  _hoisted_14
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})